export default __webpack_public_path__ + "static/media/nav-arrow-blue.82693dac.svg";